var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 22229",
    transform: "translate(-3014.5 -5354)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon/Container/56x56",
    transform: "translate(3014.5 5354)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/external/link/black",
    transform: "translate(3033.5 5368.263)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/external/link"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4",
    transform: "translate(0 0.612)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 1",
    d: "M17,8.4v7.2a2.474,2.474,0,0,1-.664,1.7,2.205,2.205,0,0,1-1.6.7H2.266A2.336,2.336,0,0,1,0,15.6V2.4A2.336,2.336,0,0,1,2.266,0h6.8",
    transform: "translate(0 5.125)",
    fill: "none",
    stroke: "#233588",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 2",
    d: "M0,0H7V8",
    transform: "translate(14 0.125)",
    fill: "none",
    stroke: "#233588",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 3",
    d: "M0,14,13,0",
    transform: "translate(8 0.125)",
    fill: "none",
    stroke: "#233588",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkNormal);
export default __webpack_public_path__ + "static/media/link-normal.db31ab92cd15e50e2a47108eb845457b.svg";
export { ForwardRef as ReactComponent };